import { ProductStatus } from '../types/shared/products.js';

const stockThresholds = {
    OUT_OF_STOCK: 0,
    ONE_LEFT: 1,
    TWO_LEFT: 2,
    FEW_LEFT: 5
};
const mapProductStockToProductStatus = (stockCount, isPublished)=>{
    if (!isPublished) {
        return ProductStatus.NOT_FOR_SALE;
    }
    if (stockCount === stockThresholds.OUT_OF_STOCK) {
        return ProductStatus.OUT_OF_STOCK;
    }
    if (stockCount === stockThresholds.ONE_LEFT) {
        return ProductStatus.AVAILABLE_ONE_LEFT;
    }
    if (stockCount === stockThresholds.TWO_LEFT) {
        return ProductStatus.AVAILABLE_TWO_LEFT;
    }
    if (stockCount <= stockThresholds.FEW_LEFT) {
        return ProductStatus.AVAILABLE_FEW_LEFT;
    }
    return ProductStatus.AVAILABLE;
};

export { mapProductStockToProductStatus };
//# sourceMappingURL=map-product-stock-to-product-status.js.map
